import { IApiMember } from '../member/member.types';
import { IApiMessage } from '../message';
import { IRelationship } from '../models.types';
import { IApiPagination } from '../pagination/pagination.types';
import { IApiPicture } from '../picture';

export interface IApiThread {
  type: 'thread';
  id: string;
  attributes: {
    createdBy: string;
    lastMessageId: string;
    replied: number;
    unreadMessagesCount: number;
  };
  relationships: {
    lastMessage: IRelationship<'message'>;
    mainPicture: IRelationship<'picture'>;
    otherMember: IRelationship<'member'>;
    photoRevealStatus: IRelationship<'photoRevealStatus'>;
    lastConnection?: IRelationship<'lastConnection'>;
  };
}

export interface IThread {
  id: string;
  relationships: {
    accountId: string;
    threadMainPicture: string;
    messages: {
      list: string[];
      meta: {
        total?: number;
        current_page?: number;
      };
    };
  };
  permissions: Partial<Record<EThreadPermission, boolean>>;
}

export enum EThreadPermission {
  CAN_POST_MESSAGE = 'CAN_POST_MESSAGE',
}

export interface IApiThreadsResult {
  data: IApiThread[];
  included: Array<IApiMember | IApiPicture | IApiMessage>;
  meta: {
    pagination: IApiPagination;
  };
}
